export default __webpack_public_path__ + "static/media/hero-image.dfb7ce7a.svg";